export default __webpack_public_path__ + "static/media/ml.abd95c9b.svg";